import { Done } from '@mui/icons-material';

import { PillPaper, PillText } from './styles';

const SessionPill = ({ children, sx }) => {
  return (
    <PillPaper elevation={0} sx={sx}>
      <Done sx={{ height: '34px', width: '28px' }} />
      <PillText>{children}</PillText>
    </PillPaper>
  );
};

export default SessionPill;
